import React, { useEffect, useState } from "react";
import "./PagoAOperador.scss";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Chip } from 'primereact/chip'; // Seguimos usando Chip, ¡es perfecto para esto!
import { Tag } from 'primereact/tag'; // Podemos considerar Tag si queremos algo aún más simple.
import Filtros from "./partes/Filtros";
import { getOperadores } from "../Bitacoras/integracion";
import Indicadores from "./partes/Indicadores";
import Tabla from "./partes/Tabla";
import { getPagoOperador } from "./integracion";

export default function PagoAOperador() {
    const [filtros, setFiltros] = useState({
        operador: null,
        desde: new Date(),
        hasta: new Date()
    });

    const [datos, setDatos] = useState(null);
    const [indicadores, setIndicadores] = useState(null);

    const [operadores, setOperadores] = useState([])
    useEffect(() => {
        getOperadores(setOperadores)
    }, [])
    const buscar = async () => {
        // Simulación de carga de datos e indicadores
        getPagoOperador(setDatos, filtros);
    };
    useEffect(() => {
        if (datos) {
            console.log("datos", datos);
            console.log("datos.indicadores[0]?.EMPRESARIAL", datos.indicadores);

            setIndicadores({
                operador: datos.data[0].OPERADOR,
                empresarial: datos.indicadores[0]?.EMPRESARIAL,
                especiales: datos.indicadores[0]?.ESPECIALES,
                kmTotal: datos.indicadores[0]?.KM_TOTAL,
                taller: datos.indicadores[0]?.TALLER,
                sueldoGarantia: datos.indicadores[0]?.SUELDO_GARANTIA,
                dias: datos.indicadores[0]?.DIAS,
                domingo: datos.indicadores[0]?.DOMINGOS,
                viajesDomingoEmpresarial: datos.indicadores[0]?.VIAJES_EMPRESARIAL_DOMINGO,
                pagoDomingoEmpresarial: datos.indicadores[0]?.PAGO_DOMINGO_EMPRESARIAL,
                bonoDomingoEmpresarial: datos.indicadores[0]?.BONO_DOMINGO_EMPRESARIAL
            });
        }
    }, [datos])
    console.log("indicadores", indicadores);


    const templateBooleanIcon = (value) => {
        console.log("value", value)
        return (
            < i
                className={`pi ${value==1 ? "pi-check" : "pi-times"}`
                }
                style={{ color: value==1 ? "var(--green-500)" : "var(--red-500)" }
                }
            ></i >
        )
    }


    return (
        <div className="vista-reporte-operador">
            <Filtros setFiltros={setFiltros}
                filtros={filtros}
                operadores={operadores}
                setIndicadores={setIndicadores}
                setDatos={setDatos}
                datos={datos?.data}
                buscar={buscar}
            ></Filtros>

            {indicadores && (
                <Indicadores
                    indicadores={indicadores}
                    templateBooleanIcon={templateBooleanIcon}
                    filtros={filtros}
                />
            )}

            <Tabla datos={datos?.data} templateBooleanIcon={templateBooleanIcon}></Tabla>
        </div>
    );
}